<template>
    <template
        v-for="{ fieldName, fieldValue } in fields"
        :key="fieldName"
    >
        <template v-if="!omitProperties.includes(fieldName)">
            <input
                v-if="isFile(fieldValue)"
                :ref="inputElement => assignFile(inputElement, fieldValue)"
                class="hidden"
                :name="fieldName"
                type="file"
            />
            <input
                v-else
                :name="fieldName"
                type="hidden"
                :value="fieldValue"
            />
        </template>
    </template>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
    formData?: FormData;
    omitProperties: string[];
}>();

const fields = ref<{ fieldName: string; fieldValue: FormDataEntryValue }[]>([]);

watch(
    () => props.formData,
    formData => {
        fields.value = [];
        if (!formData) return;
        for (const [fieldName, fieldValue] of formData.entries()) {
            fields.value.push({ fieldName, fieldValue });
        }
    },
    { immediate: true },
);

const isFile = (value: FormDataEntryValue): value is File => value instanceof File;

const assignFile = (inputElement: unknown, file: File) => {
    if (!(inputElement instanceof HTMLInputElement)) return;
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    inputElement.files = dataTransfer.files;
};
</script>
